<mat-form-field appearance="outline" class="full-width">
  <mat-label>{{ label }}</mat-label>

  <mat-select
    [multiple]="multiSelect"
    [formControl]="selectControl"
    [placeholder]="placeholder"
    (openedChange)="handleOpenedChange($event)">

    <mat-option>
      <ngx-mat-select-search
        [formControl]="searchControl"
        [placeholderLabel]="searchPlaceholder"
        [noEntriesFoundLabel]="noEntriesFoundLabel">
      </ngx-mat-select-search>
    </mat-option>

    <mat-option
      *ngFor="let option of filteredOptions$ | async"
      [value]="useAdvancedValue ? option.advancedValue : option.id">
      {{ option.name }}
    </mat-option>
  </mat-select>
</mat-form-field>
